import { ACTION_ADD_EXTERNAL_ACCOUNT_REJECTED } from '../../containers/addExternalAccount/addExternalAccount.reducers';
import pageAnalytics from '../pageAnalytics';
import { ANALYTICS_ADD_EXTERNAL_BANK_START } from '../actions';
import pageTrack from '../pageAnalytics.constants';

const initData = {
  account_type: 'generic',
  pagekind: 'transfers',
  pagefunction: 'add_external_bank',
  pagesubfunction: 'servicing',
} as const;

const viewSuccess = () => {
  pageAnalytics
    .newPageView(initData)
    .addInfo({
      pagename: 'start',
      attr: pageTrack.attr.ews,
    })
    .record();
};

const viewFailure = () => {
  pageAnalytics
    .newPageView(initData)
    .addInfo({
      pagename: 'start_submit_error',
    })
    .record();
};

export const newExternalBankAccPageEvents = {
  [ANALYTICS_ADD_EXTERNAL_BANK_START]: viewSuccess,
  [ACTION_ADD_EXTERNAL_ACCOUNT_REJECTED]: viewFailure,
} as const;

export default newExternalBankAccPageEvents;
